var React = require('react');

function Mark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M678.974 133.331L562.566 200.002L446.158 266.663L329.741 333.333V466.665V533.335V599.996V666.667V733.337L446.158 666.667L562.566 599.996V533.335V466.665L446.158 533.335V400.004L562.566 333.333L678.974 266.663V333.333V400.004V466.665V533.335V599.996V666.667L562.566 733.337L446.158 799.998L329.741 866.669L213.333 933.33L329.741 1000L446.158 933.33L562.566 866.669L678.974 799.998L795.391 733.337V599.996V466.665V333.333V282.195V200.002V66.6705L678.974 0V133.331Z","fill":"#060917"}));
}

Mark.defaultProps = {"viewBox":"0 0 1000 1000","fill":"none"};

module.exports = Mark;

Mark.default = Mark;
